import Logo from "@/assets/images/name2.png";
import RulesConfirmation from "@/components/rules/RulesConfirmation";
import { useAuth } from "@/context/auth";
import { IconArrowUpLeft, IconCalendar, IconMessage, IconShieldCheck, IconUsers } from "@tabler/icons-react";
import { useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import classes from "./auth.module.css";

export default function AuthLayout() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isLogin = /\/auth\/?$|\/auth\/login\/?$/i.test(pathname);
  const title = isLogin ? "ورود به پدیکس" : /signup/i.test(pathname) ? "به پدیکس بپیوندید" : /verification/i.test(pathname) ? "ورود به حساب کاربری" : "بازیابی حساب کاربری";

  useEffect(() => {
    if (token) navigate("/dashboard", { replace: true });
  }, [token, navigate]);

  return (
    <main className={classes.page} dir="rtl">
      <header className={classes.header}>
        <Link to="/auth/login" className={classes.brand} aria-label="پدیکس، صفحه ورود">
          <img src={Logo} alt="" width={42} height={42} />
          <span>پدیکس</span>
        </Link>
        <div className={classes.headerEnd}><span>همراه کسب‌وکار شما</span><a href="https://t.me/padix_support" target="_blank" rel="noopener noreferrer">پشتیبانی</a></div>
      </header>
      <div className={classes.shell}>
        <section className={classes.story} aria-label="معرفی پدیکس">
          <span className={classes.eyebrow}><span /> همراه رشد کسب‌وکار شما</span>
          <div className={classes.emblem} aria-hidden="true">
            <div className={classes.orbit} />
            <img src={Logo} alt="" width={330} height={330} />
            <span className={classes.spark}>✦</span>
          </div>
          <h2>برای کسب‌وکارتان،<br /><span>همه‌چیز یک‌جا در پدیکس.</span></h2>
          <p className={classes.storyText}>از مدیریت نوبت‌ها و مشتریان تا ثبت فاکتور و ارسال پیامک؛<br />با خیال راحت‌تر، روی رشد کسب‌وکارتان تمرکز کنید.</p>
          <div className={classes.features}>
            <div><IconCalendar size={20} /><span>نوبت‌ها</span></div>
            <div><IconUsers size={20} /><span>مشتریان</span></div>
            <div><IconMessage size={20} /><span>پیامک‌ها</span></div>
          </div>
          <div className={classes.storyFooter}><span>یک نگاه روشن به تمام کارها</span><IconArrowUpLeft size={21} /></div>
        </section>
        <section className={classes.formSide} aria-labelledby="auth-title">
          <div className={classes.formContent}>
            <span className={classes.formIcon}><IconShieldCheck size={26} stroke={1.6} /></span>
            <p className={classes.welcome}>به فضای کسب‌وکار خود خوش آمدید</p>
            <h1 id="auth-title">{title}</h1>
            {isLogin && <p className={classes.subtitle}>برای ورود یا ثبت‌نام، شماره موبایل خود را وارد کنید.</p>}
            <div className={classes.fields}><Outlet /></div>
            <div className={classes.help}><RulesConfirmation /></div>
          </div>
        </section>
      </div>
      <footer className={classes.footer}><span>پدیکس؛ همراه کسب‌وکار شما</span><span dir="ltr">PADIX</span></footer>
    </main>
  );
}
